import { DetailsSkillDevelopment } from './details-skill-development.component';

export default DetailsSkillDevelopment;
